import type { Params } from "../toQueryString";
import { buildPath } from "./buildPath";

const BASE_PATH = "/internal_api/circle_ai/projects";

export const circleAiProjects = {
  list: ({ params = {} }: { params?: Params } = {}) =>
    buildPath(BASE_PATH, params),
  archived: ({ params = {} }: { params?: Params } = {}) =>
    buildPath(`${BASE_PATH}/archived`, params),
  show: ({ uuid }: { uuid: string }) => buildPath(`${BASE_PATH}/${uuid}`),
  create: () => buildPath(BASE_PATH),
  update: ({ uuid }: { uuid: string }) => buildPath(`${BASE_PATH}/${uuid}`),
  archive: ({ uuid }: { uuid: string }) =>
    buildPath(`${BASE_PATH}/${uuid}/archive`),
  unarchive: ({ uuid }: { uuid: string }) =>
    buildPath(`${BASE_PATH}/${uuid}/unarchive`),
  destroy: ({ uuid }: { uuid: string }) => buildPath(`${BASE_PATH}/${uuid}`),
  files: {
    index: ({ uuid, params = {} }: { params?: Params; uuid: string }) =>
      buildPath(`${BASE_PATH}/${uuid}/files`, params),
    destroy: ({ uuid, id }: { id: number; uuid: string }) =>
      buildPath(`${BASE_PATH}/${uuid}/files/${id}`),
  },
};
